<div
  class="[ hero ][ relative w-full min-h-full ][ flex flex-wrap justify-center gap-m ][ p-i-l p-b-m ][ corner-l ]"
  data-cy="hero-section"
  >
  <div
    class="cta-form [ relative flex flex-column items-center flex-1 gap-m ][ p-m m-b-auto ][ surface elevation-5 border border-stroke-variant ][ corner-m ]"
    #cta
    >
    <dcr-logo logo="logo:banner" class="cta-logo"></dcr-logo>

    @if (isMaintenanceMode$ | async) {
      <campus-maintenance-mode
        [statusPageUrl]="statusPageUrl"
      ></campus-maintenance-mode>
    } @else {
      @if (user$ | async; as user) {
        <div class="title-medium" data-cy="logged-in-welcome-message">
          Welkom terug
          @if (user.firstName) {
            <span>, {{ user.firstName }}!</span>
          }
        </div>
        <dcr-tonal-button
          label="Naar het platform"
          leading-icon="portal:rocket"
          (click)="goToPlatform()"
          data-cy="btn-platform-link"
        ></dcr-tonal-button>
      } @else {
        <div class="actions" data-cy="login-links">
          <dcr-tonal-button label="Aanmelden" href="login" data-cy="btn-login-link"></dcr-tonal-button>
          <dcr-inline-button
            label="Ik ben een schoolbeheerder"
            href="login?role=schooladmin"
            data-cy="btn-login-link"
          ></dcr-inline-button>
        </div>
      }
    }


    <dcr-animated-kai
      #kai
      src="assets/rive/kai_state_machine.riv"
      autoplay
      track-lookat
      react-to-click
      class="animated-kai"
      (load)="loadedKai($event)"
    ></dcr-animated-kai>
  </div>

  <dcr-image
    class="hero-image [ w-full items-center justify-end flex-1 ]"
    src="/assets/images/illustrations/dashboard_hero.png"
    fit="contain"
    autofill
    aspect-ratio="1/1"
    alt="Een inktvis zwemt tussen methodes van die Keure"
  ></dcr-image>
</div>

<campus-about-section
  title="Wat is Polpo?"
  anchor="about"
  readMoreLink="https://www.diekeure.be/educatief/polpo/"
  videoId="K7w2aNMqqzo"
  player="youtube"
  class="about"
  >
  Polpo is het digitale platform van die Keure voor het secundair onderwijs. Je vindt er bordboeken, lessuggesties,
  oefeningen en extra digitaal materiaal bij jouw lesmethodes. De leerkracht tijdswinst bezorgen en de leerling
  leerwinst, dat is de missie van Polpo.
</campus-about-section>

<campus-about-section
  title="die Keure"
  anchor="diekeure"
  videoId="1yRf_0lYrgQ"
  player="youtube"
  readMoreLink="https://www.diekeure.be"
  class="diekeure"
  >
  Als Vlaamse uitgeverij ontwikkelen we lesmethodes en digitale tools om jouw leerlingen met plezier te laten leren, in
  hun talenten te groeien en de wereld te ontdekken. Daarmee volgen we onze passie voor het onderwijs en de missie die
  we delen met elke leerkracht in het veld: elke leerling zo goed mogelijk onderwijzen en zich daardoor maximaal te
  laten ontplooien. Op ons leerplatform Kabas omarmen we dan ook enthousiast vol ambitie de vele mogelijkheden die de
  digitalisering biedt. Want onderwijs doet ertoe!
</campus-about-section>

<campus-faq-section></campus-faq-section>

<campus-contact-section
  [subjects]="subjects"
  [user]="user$ | async"
  [success]="contactSuccess$ | async"
  (submitForm)="contactFormSubmitted($event)"
></campus-contact-section>
